const calculateCakePrice = (
  cake,
  selectedSizeId,
  selectedFlavorId,
  customizations = {}
) => {
  if (!cake) return 0;

  const basePrice = cake.basePrice || 0;

  const sizeObj = cake.sizes.find((s) => s._id === selectedSizeId);
  const flavorObj = cake.flavors.find((f) => f._id === selectedFlavorId);

  const sizePrice = sizeObj?.price || 0;
  const flavorPrice = flavorObj?.price || 0;

  let characterPrice = 0;

  const charField = cake.customizationFields?.find(
    (f) => f.type === "characterList" && customizations[f.key]
  );

  if (charField) {
    const characters = customizations[charField.key]; // e.g., [{ type: 'letter', char: 'A' }, ...]
    const filtered = Array.isArray(characters)
      ? characters.filter((c) => c?.char?.trim())
      : [];

    const baseCount = charField.baseCharacterCount ?? 1; // ✅ Default to 1 included
    const perChar = charField.pricePerExtraCharacter ?? 60; // ✅ Default to $60

    const extraCount = Math.max(0, filtered.length - baseCount);
    characterPrice = extraCount * perChar;
  }

  return parseFloat(basePrice + sizePrice + flavorPrice + characterPrice);
};

export default calculateCakePrice;
